import React from 'react';
import './Pricing.css';
import { FaCheckCircle } from 'react-icons/fa';
import { FaDiscord } from 'react-icons/fa';
// Removed the paymentMethods import and added individual payment icons:
import paypalImg from './paypal.png';
import visaImg from './visa.png';
import mastercardImg from './mastercard.png';
import aliplayImg from './alipay.png';
import bitcoinImg from './bitcoin.png';
import etherImg from './ether.png';
import skinsImg from './skins.png';
import giftcardsImg from './giftcards.png';
import tetherImg from './tether.png';
import webmoneyImg from './webmoney.png';
import unionpayImg from './unionpay.png';

const Pricing = () => {
  const pricingData = [
    {
      title: "1-Week-Trial",
      description: "3$ / 7 days",
      features: ["Undetected", "Custom Build", "Hotkeys", "Updates & Support", "Anti-AFK"],
      link: "https://www.digiseller.market/asp2/pay_wm.asp?id_d=5116221&lang=en-EN"
    },
    {
      title: "1-Month",
      description: "7$ / 30 days",
      features: ["Undetected", "Custom Build", "Hotkeys", "Updates & Support", "Anti-AFK"],
      link: "https://www.digiseller.market/asp2/pay_wm.asp?id_d=5116228&lang=en-EN"
    },
    {
      title: "3-Months",
      description: "14$ / 90 days",
      features: ["Undetected", "Custom Build", "Hotkeys", "Updates & Support", "Anti-AFK"],
      link: "https://www.digiseller.market/asp2/pay_wm.asp?id_d=5116232&lang=en-EN"
    },
  ];

  return (
    <div className="pricing-component" id="pricing">
      {/* Neuer Header-Bereich */}
      <div className="pricing-header">
        <h2>Pricing</h2>
        <p className="pricing-header-text">Select the plan that suits your needs</p>
      </div>

      {/* Pricing Wrapper */}
      <div className="pricing-wrapper">
        <div className="pricing-inner">
          {pricingData.slice(0,2).map((plan, index) => {
            const parts = plan.description.split('/');
            const pricePart = parts[0].trim();
            const periodPart = parts[1] ? parts[1].trim() : "";
            const hardwareLink = plan.title === "1-Week-Trial"
              ? "https://www.digiseller.market/asp2/pay_wm.asp?id_d=5198867&lang=en-EN"
              : plan.title === "1-Month"
                ? "https://www.digiseller.market/asp2/pay_wm.asp?id_d=5198892&lang=en-EN"
                : "";
            return (
              <div key={index} className="pricing-box">
                <h3>{plan.title}</h3>
                <p className="pricing-description">
                  <span className="price-number">{pricePart}</span> {periodPart && <span className="pricing-period">/ {periodPart}</span>}
                </p>
                <div className="pricing-features">
                  {plan.features.map((feature, idx) => (
                    <div key={idx} className="pricing-feature">
                      <FaCheckCircle className="feature-icon" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
                <a href={plan.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <button className="pricing-button">Purchase Software Version</button>
                </a>
                <a href={hardwareLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', marginTop: '10px' }}>
                  <button className="pricing-button">Purchase Hardware Version</button>
                </a>
              </div>
            );
          })}
          {pricingData.slice(2).map((plan, index) => {
            const parts = plan.description.split('/');
            const pricePart = parts[0].trim();
            const periodPart = parts[1] ? parts[1].trim() : "";
            const hardwareLink = plan.title === "3-Months"
              ? "https://www.digiseller.market/asp2/pay_wm.asp?id_d=5198901&lang=en-EN"
              : "";
            return (
              <div key={index + 2} className="pricing-box">
                <h3>{plan.title}</h3>
                <p className="pricing-description">
                  <span className="price-number">{pricePart}</span> {periodPart && <span className="pricing-period">/ {periodPart}</span>}
                </p>
                <div className="pricing-features">
                  {plan.features.map((feature, idx) => (
                    <div key={idx} className="pricing-feature">
                      <FaCheckCircle className="feature-icon" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
                {/* Beispiel für einen inaktiven Button */}
                <a href={plan.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <button disabled className="pricing-button">Purchase Software Version</button>
                </a>
                <a href={hardwareLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', marginTop: '10px' }}>
                  <button className="pricing-button">Purchase Hardware Version</button>
                </a>
              </div>
            );
          })}
          {/* Neue Lifetime Access Box */}
          <div className="pricing-box" style={{ border: "1px solid #CAF881" }}>
            <h3>Lifetime Access</h3>
            <p className="lifetime-original-price" style={{ textDecoration: 'line-through', fontSize: '30px', color: '#555', marginBottom: '5px' }}>
              $90 USD
            </p>
            <p className="pricing-description">
              <span className="price-number">50$</span> <span className="limited-offer">(Limited offer)</span>
            </p>
            <div className="lifetime-text">
              Buy it once and own it forever! All features included + Special Role on Discord.
            </div>
            <a href="https://www.digiseller.market/asp2/pay_wm.asp?id_d=5200323&lang=en-EN" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="pricing-button">Purchase Software Version</button>
            </a>
            <a href="https://www.digiseller.market/asp2/pay_wm.asp?id_d=5200323&lang=en-EN" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', marginTop: '10px' }}>
              <button className="pricing-button">Purchase Hardware Version</button>
            </a>
          </div>
        </div> {/* End of .pricing-inner */}
      </div> {/* End of .pricing-wrapper */}
      {/* Combined container for Payment Grids and Discord */}
      <div className="pricing-additional-wrapper">
        <div className="additional-box payment-methods-box">
          <div style={{ display: "flex", alignItems: "center", gap: "25px", justifyContent: "center" }}>
            <span style={{ 
              fontFamily: "'Inter', sans-serif", 
              color: "#ffffff", 
              fontSize: "18px", 
              fontWeight: "bold" 
            }}>
              Pay with:
            </span>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.1rem" }}>
              {/* Erstes unabhängiges Grid */}
              <div className="pricing-payment-grid">
                <div className="grid-item">
                  <img src={paypalImg}    alt="PayPal"       title="PayPal" />
                </div>
                <div className="grid-item">
                  <img src={visaImg}      alt="Visa"         title="Visa" />
                </div>
                <div className="grid-item">
                  <img src={mastercardImg}alt="Mastercard"   title="Mastercard" />
                </div>
                <div className="grid-item">
                  <img src={aliplayImg}   alt="Alipay"       title="Alipay" />
                </div>
                <div className="grid-item">
                  <img src={bitcoinImg}   alt="Bitcoin"      title="Bitcoin" />
                </div>
                <div className="grid-item">
                  <img src={etherImg}     alt="Ether"        title="Ethereum" />
                </div>
              </div>
              {/* Zweites unabhängiges Grid */}
              <div className="pricing-payment-grid" style={{ marginTop: "0.2rem" }}>
                <div className="grid-item">
                  <img src={skinsImg}     alt="Skins"        title="Pay with Skins" />
                </div>
                <div className="grid-item">
                  <img src={giftcardsImg} alt="Gift Cards"   title="Pay with Giftcards" />
                </div>
                <div className="grid-item">
                  <img src={tetherImg}    alt="Tether"       title="Tether" />
                </div>
                <div className="grid-item">
                  <img src={webmoneyImg}  alt="Webmoney"     title="Webmoney" />
                </div>
                <div className="grid-item">
                  <img src={unionpayImg}  alt="UnionPay"     title="UnionPay" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="additional-box discord-box">
          <div style={{ display: "flex", alignItems: "center", gap: "25px", justifyContent: "center" }}>
            <span style={{ 
              fontFamily: "'Inter', sans-serif", 
              color: "#ffffff", 
              fontSize: "18px", 
              fontWeight: "bold" 
            }}>
              Need Support? Join our Discord!
            </span>
            <button
              className="pricing-discord-button"
              onClick={() => window.open("https://eaglescript.space:5989/", "_blank")}
            >
              <FaDiscord />
              <span>Discord</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
